import type { ItemSlotType } from '../api/types';
import { ITEM_ICON_ASSETS, UI_ICON_ASSETS, type UiIconAssetKey } from '../assets/registry';
import { versionedAssetUrl } from '../assets/version';
import { esc } from './components';

interface IconAsset {
  id: string;
  url: string;
  label: string;
}

const ITEM_ICON_BY_SLOT: Record<ItemSlotType | 'relic', IconAsset> = {
  weapon: { id: 'item_common_weapon_01', url: ITEM_ICON_ASSETS.commonWeapon, label: 'Weapon' },
  armor: { id: 'item_common_armor_01', url: ITEM_ICON_ASSETS.commonArmor, label: 'Armor' },
  trinket: { id: 'item_common_trinket_01', url: ITEM_ICON_ASSETS.commonTrinket, label: 'Trinket' },
  lantern: { id: 'item_common_lantern_01', url: ITEM_ICON_ASSETS.commonLantern, label: 'Lantern' },
  relic: { id: 'item_common_relic_01', url: ITEM_ICON_ASSETS.commonRelic, label: 'Relic' },
};

const UI_ICON_LABEL: Record<UiIconAssetKey, string> = {
  hp: 'HP',
  lantern: 'Lantern',
  burden: 'Burden',
  gold: 'Gold',
  ferryPass: 'Ferry Pass',
};

export function itemIconForSlot(slotType: string | null | undefined): IconAsset | null {
  return slotType && slotType in ITEM_ICON_BY_SLOT
    ? ITEM_ICON_BY_SLOT[slotType as keyof typeof ITEM_ICON_BY_SLOT]
    : null;
}

export function iconImg(asset: IconAsset | null, kind: 'item' | 'ui'): string {
  if (!asset) return '';
  return `<img class="asset-icon asset-icon--${kind}" src="${esc(versionedAssetUrl(asset.url))}" alt="" aria-hidden="true" loading="lazy" decoding="async" data-asset-id="${esc(asset.id)}" />`;
}

export function itemIcon(slotType: string | null | undefined): string {
  return iconImg(itemIconForSlot(slotType), 'item');
}

export function resourceIcon(kind: UiIconAssetKey): string {
  return iconImg({ id: `ui_${kind === 'ferryPass' ? 'ferry_pass' : kind}_01`, url: UI_ICON_ASSETS[kind], label: UI_ICON_LABEL[kind] }, 'ui');
}

export function iconRow(label: string, iconKind: UiIconAssetKey, value: string): string {
  return `<div class="kv kv--icon"><dt>${resourceIcon(iconKind)}<span>${esc(label)}</span></dt><dd>${value}</dd></div>`;
}
